import {createFileRoute} from '@tanstack/react-router';
import {LogoutPage} from 'pages/login/LogoutPage';

export const Route = createFileRoute('/logout')({
  component: LogoutPage,
});
